// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__38lIP","AuthForm":"Auth_AuthForm__2w9p_"};